import React from "react";
import Layout from "../components/Layout";
import "./Upload.css";
import { useState, useEffect } from "react";
import LoadImage from "./LoadImage";
import Removebg from "../components/Removebg";
import Display from "../components/Display";
// import { TailSpin } from "react-loader-spinner";
import Loading from "../components/Loading";
import { useUserAuth } from "../context/UserAuthContext";

import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  uploadBytesResumable,
  uploadString,
} from "firebase/storage";
import { storage } from "../FirebaseConfig";
import { db } from "../FirebaseConfig";
import { v4 as uuid } from "uuid";
import { doc, setDoc, updateDoc, arrayUnion } from "firebase/firestore";
import { srcUpload, predictUpload } from "../ultis";
export default function Upload() {
  // const [img, setImg] = useState("");
  const [imgPredict, setImgPredict] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imgUpload, setImgUpload] = useState(null);
  const [imgSrc, setImgSrc] = useState();
  const { user } = useUserAuth();
  const [urlDownload, getUrlDownload] = useState("");
  // const [base64Url, setBase64Url] = useState("");
  // upload image to firebase

  const uploadImageFile = async () => {
    //
    if (!imgUpload && !imgPredict) return;
    if (!user) return;
    const unique_id = uuid();
    let nameImgSrcSave = unique_id + "_src.png";
    let nameImgPreSave = unique_id + "_predict.png";
    const srcI = srcUpload(storage, nameImgSrcSave, imgUpload);
    const preI = predictUpload(storage, nameImgPreSave, imgPredict);
    const updateData = doc(db, "users", user.email);

    const promises = [srcI, preI];
    Promise.all(promises)
      .then(async ([urlSrc, urlPre]) => {
        const linkDownloads = { srcImg: urlSrc, predImg: urlPre };
        getUrlDownload(linkDownloads);
        if(urlDownload){
          await updateDoc(updateData, {
            ImgPaths: arrayUnion(urlDownload)
        })
        }
        
      console.log("All images uploaded", urlSrc, urlPre)
      })
      .then((err) => console.log(err));

    // if(urlDownload){
    //   console.log(urlDownload)
      
      
    // }
  };

  useEffect(() => {
    uploadImageFile();
    getUrlDownload("")
  }, [imgPredict]);
  return (
    <Layout>
      <div className="container-upload">
        <h2
          style={{
            color: "rgb(84, 97, 108)",
            fontSize: "30px",
            margin: "1rem auto",
          }}
        >
          Upload an image to remove the background{" "}
        </h2>
        <div className="upload">
          <LoadImage
            setImgPredict={setImgPredict}
            loading={loading}
            setLoading={setLoading}
            setImgSrc={setImgSrc}
            setImgUpload={setImgUpload}
          />
        </div>
      </div>

      {loading && <Loading />}
      {imgSrc && (
        <div className="display-container">
          <Display
            imgSrc={imgSrc}
            imgPredict={imgPredict}
            setImgSrc={setImgSrc}
          />
        </div>
      )}
      {imgSrc && (
        <h2
          style={{
            width: "60%",
            margin: "1rem auto",
            textAlign: "center",
            fontSize: "30px",
            color: "rgb(84, 97, 108)",
          }}
        >
          Image Preview
        </h2>
      )}
      {imgSrc && (
        <div className="upload-show">
          <div className="upload-btn">
            <Removebg imgOrigin={imgSrc} imgRmBg={imgPredict} />
          </div>
        </div>
      )}
    </Layout>
  );
}
